import BaseButton from "../base-button";
import {buttonEnum, positionEnum, dimensionEnum, scaleEnum} from "../helper";
import VrButtonContainer from "./vr-button-container";

class VrMenu extends BaseButton {
    mesh;
    prevPortraitMode = false;
    prevLandscapeMode = true;
    prevPosition = new THREE.Vector3(.08, 0, 0);

    constructor(parent) {
        const {scale} = mapScreenDimensionTo3D(positionEnum.MENU_TOGGLE, dimensionEnum.MENU_VR);
        super({
            text: "Main\nMenu",
            parent: parent,
            position: new THREE.Vector3(.08, 0, 0),
            isSprite: false,
            scale: scale,
            name: buttonEnum.MENU,
            isVisible: false
        });

        this.setCallback(this.buttonClickCallback);
    }

    onVRModeChange() {
        if (isVRModeEnabled() && mController.hasAnyVisibleContent()) {
            setTimeout(() => {
                this.setVisibility(true);

                this.modifyScale(scaleEnum);


                if (MenuHelpers.isTabletLandscapeMode()) {
                    const buttonHeight = this.buttonContainer.scale.y || this.scale.y || 0.75;
                    const downwardOffset = buttonHeight * 0.8;
                    this.prevPosition.copy(this.position);
                    this.position.set(.2, 1 - downwardOffset, -.5);
                } else if (isLandscapeMode() && isMobileDevice()) {
                    this.prevLandscapeMode = true;
                    this.prevPosition.copy(this.position);
                    this.position.set(.2, 1, -.5);
                }

                if (isPortraitMode() && isMobileDevice()) {
                    this.prevPortraitMode = true;
                    this.prevPosition.copy(this.position);
                    this.position.set(.08, 1, 0);
                }

                this.setLocationAndScaling();

                if (isMobileARModeEnabled()) {
                    VrButtonContainer.getInstance().changeParent(iq3Camera.camera);
                }

            }, 500);
        } else {
            if (this.prevLandscapeMode || this.prevPortraitMode) {
                this.position.copy(this.prevPosition);

            }

            this.prevPortraitMode = false;
            this.prevLandscapeMode = false;
            this.setLocationAndScaling();
            this.setVisibility(false);
        }

    }

    async buttonClickCallback() {
        if (!mController.hasAnyVisibleContent() || !wv.effectController.meetingInfo.data.menuEnabled) {
            VRMessageController.addMessage({
                text: "Menu disabled for this workspace",
                priority: VrMessagePriorityEnum.HIGHPRIORITYINFO
            });
            return false;
        }

        const updateMenuPosition = () => {
            let currentPosition = new THREE.Vector3();
            let distVec = new THREE.Vector3();
            distVec.subVectors(cameraTracker.position, currentPosition);
            currentPosition.add(distVec);

            currentPosition.y += isPortraitMode() ? positionEnum.MENU_VR.yAxisMenuPosition : positionEnum.MENU_VR_LANDSCAPE.yAxisMenuPosition;
            currentPosition.z += positionEnum.MENU_VR.zAxisMenuPosition;
            const menuObject = mController.menuDataView.getMenuObject();
            menuObject.scale.set(1, 1, 1);
            menuObject.position.copy(currentPosition);
            menu_global_parent_position.scene.position.copy(currentPosition);
            menu_global_parent_position.scene.scale.copy(menuObject.scale);

            let rotationQuaternion = new THREE.Quaternion();
            rotationQuaternion.setFromAxisAngle(new THREE.Vector3(-.5, 0, 0), Math.PI / 4);
            menuObject.setRotationFromQuaternion(rotationQuaternion);
            menuObject.updateMatrixWorld(true);
            this.updateMenuRotationBasedPosition(cameraTracker.position);
        };

        if (mController.menuDataView.saveState) {
            updateMenuPosition();
            mController.menuDataView.loadSavedState(VR.scene);
        } else {
            await mController.menuDataView.closeMenu();
            mController.menuDataView.showMenu(VR.scene);
            updateMenuPosition();
        }

    }

}

export default VrMenu;
